export const SET_LOADING = "SET_LOADING";
export const SET_LOADING_ICON = "SET_LOADING_ICON";
export const SET_PRINTOUT_LINK = "SET_PRINTOUT_LINK";
export const IS_DEBUG = "IS_DEBUG";
export const IS_IN_MANAGEMENT = "IS_IN_MANAGEMENT";

